// extracted by mini-css-extract-plugin
export default {"status-icon":"styles__status-icon---VaFa"};